<template>
    <resources-base-table :headers="headers" :items="carrerasSede">
        <template v-slot:actions="{ item }">
            <router-link :to="{ name: 'carreraSede', params: { id: item.id } }">
                <v-icon small>carrera sede</v-icon>
            </router-link>
        </template>
    </resources-base-table>
</template>

<script>
export default {
    data: () => ({
        headers: [
            {
                sortable: false,
                text: "ID",
                value: "id"
            },
            {
                sortable: false,
                text: "Nombre",
                value: "alias"
            },
            {
                sortable: false,
                text: "Universidad",
                value: "sede.universidad.universidad"
            },
            {
                sortable: false,
                text: "Sede",
                value: "sede.sede"
            },
            { text: "Acciones", value: "action", sortable: false }
        ]
    }),
    props: ["carrerasSede"]
}
</script>
